import { createSlideIcon, type IconProps } from '../SlideTypeIcon';
const DEFAULT_COLOR = 'var(--palette-purple-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path d="M7 4H17V15.5838L12 20L7 15.5838V4Z" fill={textColor} />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    d="M10.0801 7.35986H21.9201V20.1021L16.0001 24.9599L10.0801 20.1021V7.35986Z"
    fill={textColor}
  />
);

export const ScalesIcon = createSlideIcon(Icon24x24, Icon32x32);
